import * as React from 'react';
import { themePalette } from '../../../utils/theme-palette';

const NewsFeedIcon = ({ size = 24, active = false }) => {
  const stroke = active ? 'white' : themePalette.gray;
  const fill = active ? themePalette.blue : 'none';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 28"
      fill="none"
    >
      <g id="Interface-file-text--text-common-file">
        <g id="Group">
          <path
            id="Vector"
            d="M25 25C25 25.5304 24.7893 26.0391 24.4142 26.4142C24.0391 26.7893 23.5304 27 23 27H5C4.46957 27 3.96086 26.7893 3.58579 26.4142C3.21071 26.0391 3 25.5304 3 25V3C3 2.46957 3.21071 1.96086 3.58579 1.58579C3.96086 1.21071 4.46957 1 5 1H15L25 11V25Z"
            fill={fill}
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path id="Vector_2" d="M9 9H13" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_3" d="M9 15H19" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
          <path id="Vector_4" d="M9 21H19" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
    </svg>
  );
};
export default NewsFeedIcon;
